import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { formatDateForChart } from '../../utils/dateUtils';

const ServiceTrendsChart = ({ trends = [] }) => {
    const data = (trends || []).map((point) => ({
        date: formatDateForChart(point.date),
        services: point.total_services ?? 0,
        completed: point.completed_services ?? 0,
    }));

    return (
        <div className="bg-white rounded-xl bxshadow border bxshadowh p-4">
            <h2 className="text-lg font-semibold text-gray-900 mb-1">Service Trends</h2>
            <p className="text-xs text-gray-500 mb-4">Last 7 days</p>
            {data.length === 0 ? (
                <div className="h-[300px] flex items-center justify-center text-gray-400 text-sm">
                    No trend data available
                </div>
            ) : (
                <ResponsiveContainer width="100%" height={300}>
                    <LineChart data={data}>
                        <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                        <XAxis dataKey="date" />
                        <YAxis allowDecimals={false} />
                        <Tooltip />
                        <Legend />
                        <Line
                            type="monotone"
                            dataKey="services"
                            stroke="#3B82F6"
                            strokeWidth={2}
                            dot={{ fill: '#3B82F6' }}
                            name="Created"
                        />
                        <Line
                            type="monotone"
                            dataKey="completed"
                            stroke="#10B981"
                            strokeWidth={2}
                            dot={{ fill: '#10B981' }}
                            name="Completed"
                        />
                    </LineChart>
                </ResponsiveContainer>
            )}
        </div>
    );
};

export default ServiceTrendsChart;
